import ReactDOM from 'react-dom'
import React from 'react'
// import './index.css';
import App from './app/App.js'
import 'bootstrap/dist/css/bootstrap.min.css'

ReactDOM.render(
  <>
    {/* <React.StrictMode> */}
    <App />
    {/* </React.StrictMode> */}
  </>,
  document.getElementById('root')
)
